import React from "react";
import { DateTimePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";
import setSeconds from "date-fns/setSeconds";
import { useController } from "react-hook-form";
import { useProfileLocale } from "../Common/locale";
import { enUS, enGB } from "date-fns/locale";

// import { getOrderItemSearchStartDate } from "../../helpers/methods";
const locales = { "en-US": enUS, "en-GB": enGB };

const CustomPickerInput = (props) => {
  const { source, label, options = {} } = props;
  const input = useController({ name: source });
  const locale = useProfileLocale();

  const onChangeHandler = React.useCallback(
    (date) => {
      //this is to set the seconds always zero
      if (Date.parse(date)) {
        const ts = setSeconds(new Date(date), 0);
        input.field.onChange(ts.toISOString());
      }
      input.field.onBlur();
    },
    [input]
  );

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={locales[locale]}
    >
      <DateTimePicker
        value={input.field.value ? new Date(input.field.value) : null}
        {...options}
        label={label}
        onChange={onChangeHandler}
        showToolbar
        views={["year", "month", "day", "hours", "minutes"]}
        timeSteps={{ hours: 1, minutes: 1 }}
        slots={{
          textField: TextField,
          actionBar: "div",
        }}
        slotProps={{
          textField: { fullWidth: true },
          actionBar: { actions: ["today"] },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomPickerInput;
